import { render, staticRenderFns } from "./LiveDataPublisherInfo.vue?vue&type=template&id=7a4b8dad&scoped=true&"
import script from "./LiveDataPublisherInfo.vue?vue&type=script&lang=js&"
export * from "./LiveDataPublisherInfo.vue?vue&type=script&lang=js&"
import style0 from "./LiveDataPublisherInfo.vue?vue&type=style&index=0&id=7a4b8dad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4b8dad",
  null
  
)

export default component.exports